import { useSelector } from "react-redux"
import { selectCurrentUser } from "Containers/Login/selectors"

/** Façade sur `selectCurrentUser`. Remplace la prop injectée `currentUser` du Layout. */
export const useCurrentUser = () => useSelector(selectCurrentUser)
